import {
    URLAPI,
    SKIP_TASK_PATH,
    SKIP_TASK_CREATE_PATH,
    SKIP_TASK_UPDATE_PATH
} from "../config/index";
import {LOGOUT} from './users'
import axios from "axios";

const init = {
    _get_all_skip_task: {
        data: [],

        status: 0,
        message: {},
    },

    _create_skip_task: {
        data: {},
        status: 0,
        message: {},
    },
    _update_skip_task: {
        data: {},
        status: 0,
        message: {},
    },
};

const GET_ALL_SKIP_TASK = "GET_ALL_SKIP_TASK";
export const CREATE_SKIP_TASK = "CREATE_SKIP_TASK";
export const UPDATE_SKIP_TASK = "UPDATE_SKIP_TASK";

export const skip_task_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_SKIP_TASK:
            return {
                ...state,
                _get_all_skip_task: action.payload,
            };
        case CREATE_SKIP_TASK:
            return {
                ...state,
                _create_skip_task: action.payload,
            };
        case UPDATE_SKIP_TASK:
            return {
                ...state,
                _update_skip_task: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const getAllSkipTask = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${SKIP_TASK_PATH}`, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_SKIP_TASK,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: GET_ALL_SKIP_TASK,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_SKIP_TASK,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};


export const createSkipTask = (token, data) => async (dispatch) => {
    try {
        const response = await axios.post(
            `${URLAPI}${SKIP_TASK_CREATE_PATH}`,
            data,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_SKIP_TASK,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_SKIP_TASK,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_SKIP_TASK,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateSkipTask = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(
            `${URLAPI}${SKIP_TASK_UPDATE_PATH}${id}/`,
            data,
            {
                headers: {
                    Authorization: `Basic ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_SKIP_TASK,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_SKIP_TASK,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_SKIP_TASK,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_skip_task = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
